import { useCallback, useEffect, useState } from 'react'

export const STICKY_HEADER_SELECTOR = '[data-tour-sticky-header]'
export const DEFAULT_SCROLL_OFFSET = 20

export function getStickyScrollOffset(header: Element | null): number {
  if (!header) return DEFAULT_SCROLL_OFFSET

  const stickyTop = Number.parseFloat(window.getComputedStyle(header).top)

  return (
    header.getBoundingClientRect().height +
    (Number.isFinite(stickyTop) ? stickyTop : 0) +
    DEFAULT_SCROLL_OFFSET
  )
}

export function useStickyScrollOffset() {
  const [offset, setOffset] = useState(DEFAULT_SCROLL_OFFSET)

  const measure = useCallback(() => {
    const headers = document.querySelectorAll(STICKY_HEADER_SELECTOR)
    setOffset(
      Math.max(
        DEFAULT_SCROLL_OFFSET,
        ...Array.from(headers, getStickyScrollOffset),
      ),
    )
  }, [])

  useEffect(() => {
    measure()
  }, [measure])

  return { offset, measure }
}
